import { render, staticRenderFns } from "./FloatingButton.vue?vue&type=template&id=f535f694&scoped=true"
import script from "./FloatingButton.vue?vue&type=script&lang=js"
export * from "./FloatingButton.vue?vue&type=script&lang=js"
import style0 from "./FloatingButton.vue?vue&type=style&index=0&id=f535f694&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f535f694",
  null
  
)

export default component.exports